import React, { useEffect, useState } from 'react';
import './Notices.css';
import iconBack from '../../assets/images/icon-back.svg';
import { supabase } from '../../lib/supabase';
import NoticeDetail from './NoticeDetail';

interface NoticesProps {
  onBack: () => void;
}

interface Notice {
  id: string;
  title: string;
  content: string;
  created_at: string;
  notification_type: string;
  image_url?: string;
}

const Notices: React.FC<NoticesProps> = ({ onBack }) => {
  const [notices, setNotices] = useState<Notice[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedNotice, setSelectedNotice] = useState<Notice | null>(null);

  useEffect(() => {
    fetchNotices();
  }, []);

  const fetchNotices = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('notifications')
        .select('*')
        .eq('notification_type', 'general')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('공지사항 조회 실패:', error);
        return;
      }

      setNotices(data || []);
    } catch (error) {
      console.error('공지사항 조회 오류:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).replace(/\. /g, '.').replace(/\.$/, '');
  };

  const handleNoticeClick = (notice: Notice) => {
    setSelectedNotice(notice);
  };

  const handleBackToList = () => {
    setSelectedNotice(null);
  };

  // 상세 화면 표시
  if (selectedNotice) {
    return <NoticeDetail notice={selectedNotice} onBack={handleBackToList} />;
  }

  return (
    <div className="notices-container">
      <div className="notices-header">
        <div className="notices-header-wrapper">
          <img src={iconBack} alt="뒤로가기" className="header-icon" onClick={onBack} />
          <h1 className="notices-title">공지사항</h1>
          <div className="header-icon"></div>
        </div>
      </div>

      <div className="notices-content">
        <h2 className="notices-page-title">공지사항</h2>
        {loading ? (
          <div className="notices-loading">로딩 중...</div>
        ) : notices.length === 0 ? (
          <div className="notices-empty">공지사항이 없습니다.</div>
        ) : (
          <div className="notices-list">
            {notices.map((notice) => (
              <div key={notice.id} className="notice-item" onClick={() => handleNoticeClick(notice)}>
                <h3 className="notice-title">{notice.title}</h3>
                <span className="notice-date">{formatDate(notice.created_at)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Notices;
